export default function CircularSkill({ name, value }) {
  return (
    <div className="col-6 col-lg-3">
      <div className="mil-lang-skills-item mil-center mil-mb-30">
        <div className="mil-circular-progress" data-value={`${value}%`}>
          <div className="mil-counter-frame mil-upper mil-dark">
            <span className="mil-counter" data-number={value}>
              {value}
            </span>
            <span>%</span>
          </div>
        </div>
        <h6>{name}</h6>
      </div>
    </div>
  )
}
